// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import VueI18n from 'vue-i18n';
import vuetify from '@/plugins/vuetify' // path to vuetify export

import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuebar from 'vuebar';
import { VueHammer } from 'vue2-hammer';
import Meta from 'vue-meta';
import locale from '../locale';
import store from '@/store';
import 'img-comparison-slider';

Vue.use(VueHammer);
Vue.use(Vuebar);
Vue.use(VueAxios, axios);
Vue.use(Meta);
Vue.use(VueI18n);


VueHammer.config.swipe = {
    threshold: 30
};

var lang = navigator.language.split('-');
const i18n = locale.createI18n(lang[0]);

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    vuetify,
    components: { App },
    template: '<App/>'
});

Vue.config.productionTip = false;

const languageList = ['fr', 'en', 'es', 'it', 'pt', 'ca'];
if (module.hot) {
    languageList.forEach(lang => {
        module.hot.accept([`../locale/${lang}`], () => {
            app.$i18n.setLocaleMessage(lang, require(`../locale/${lang}`).default);
        });
    });
}

// Tell Vue that the web component is present.
Vue.config.ignoredElements = [/img-comparison-slider/];



// WEBPACK FOOTER //
// ./src/main.js